import React from 'react';
import { typographyGroupLabel, truncateText } from 'lib/core';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const StyledLabel = styled.span`
  ${({ theme }) => css`
    ${truncateText};
    ${typographyGroupLabel(theme)};
    color: ${theme.color.text.light.secondary.value};
    font-size: ${theme.font.size.caption.value};
  `}
`;

export const SliderLabel = ({ children, dataTestId = '', ...other }) => (
  <StyledLabel {...{ children }} data-testid={dataTestId ? `${dataTestId}-label` : undefined} {...other} />
);

SliderLabel.propTypes = {
  /** Any content inserted between component tags */
  children: PropTypes.node.isRequired,
  /** Id value used for testing */
  dataTestId: PropTypes.string,
};
